(function () {
  const btnScrollTop = document.querySelector(".scroll-top");
  if (!btnScrollTop) return;

  const announcementBar = document.querySelector(".section-announcement");

  // Threshold = height of the announcement bar; fall back to 50px if it's absent
  let threshold = announcementBar ? announcementBar.offsetHeight : 50;

  // Keep it accurate if the bar's height changes on resize
  window.addEventListener("resize", function () {
    threshold = announcementBar ? announcementBar.offsetHeight : 50;
  });

  window.addEventListener("scroll", function () {
    if (scrollY > 10) {
      btnScrollTop.classList.add("show");
    } else {
      btnScrollTop.classList.remove("show");
    }
  });

  btnScrollTop.onclick = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
})();
